import styled, { css } from 'styled-components';

export const StyledLabel = styled.label`
    ${({ theme }) => css`
        display: block;
        margin-bottom: 0.25rem;
        font-size: 0.875rem;
        font-weight: 400;

        @media ${theme.breakpoints.large.media} {
            font-size: 1rem;
        }
    `}
`;
